import { useState, useEffect } from 'react';
import { fetchWithAuth } from './authHelpers';

export const useUserStatsByUserID = (userID, seasonId = null) => {
    const [userStats, setUserStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userID) {
            setLoading(false);
            return;
        }

        const fetchUserStats = async () => {
            try {
                setLoading(true);
                setError(null);
                const url = seasonId 
                    ? `${process.env.REACT_APP_BACKEND_URL}/userStats/${userID}?season=${seasonId}`
                    : `${process.env.REACT_APP_BACKEND_URL}/userStats/${userID}`;
                
                const response = await fetchWithAuth(url, 'GET');
                
                if (!response.ok) {
                    if (response.status === 404) {
                        throw new Error('User stats not found');
                    } else {
                        throw new Error('Failed to fetch user stats');
                    }
                }
                
                const data = await response.json();
                setUserStats(data);
            } catch (error) {
                setError(error.message);
                setUserStats(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUserStats();
    }, [userID, seasonId]);

    return { userStats, loading, error };
};
